
export const Charging = () => {
    return (
        <div className="loading">Loading&#8230;</div>
    )
}
